import React, {useState} from "react";
import {deleteItem, saveData} from "../../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import ListTable from "../../shared/ListTable";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {useMutation, useQuery} from "@apollo/client";
import {createDiseaseMutation, deleteDiseaseMutation, getDiseasesQuery} from "./DiseaseQueries";
import Loader from "../../shared/Loader";

const DiseaseList = ({ user }) => {
  const { data, loading, refetch } = useQuery(getDiseasesQuery, { variables: { clientId: user.id } })
  const [flash, setFlash] = useState({});
  const [deleteCall] = useMutation(deleteDiseaseMutation, { refetchQueries: refetch })
  const [saveCall] = useMutation(createDiseaseMutation)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createDisease',
      flash_callback: setFlash,
      success: (res) => {
        refetch()
        event.target.reset()
      }
    })
  }

  const header = <tr>
    <th>Afectiune</th>
    <th>Cronica</th>
    <th>Detalii</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.chronic ? "Da" : "Nu"}</td>
      <td>{item.details}</td>
      <td className='actions'>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
      </td>
    </tr>
  }

  return (
    <div className="container">
      <form onSubmit={onSubmit}>
        <Row className="mb-2">
          <Col>
            <FlashMessage flash={flash} />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md>
            <label htmlFor="name">Afectiune:</label>
            <input type='hidden' name='clientId' className="form-control" id="clientId" value={user.id} />
            <input type='text' name='name' className="form-control" id="name" />
            <div className="checkbox mt-3 mb-3">
              <label>
                <input type="checkbox" value="true" name="chronic" /> Afectiune Cronica
              </label>
            </div>
          </Col>
          <Col md>
            <label htmlFor="details">Detalii:</label>
            <textarea name='details' className="form-control" id="details" rows={3} />
          </Col>
          <Col className="col-auto">
            <br />
            <Button type='submit'>Adauga</Button>
          </Col>
        </Row>
      </form>
      <hr />

      {loading ?
        <Loader />
        :
        <ListTable data={data.diseases} header={header} listItem={listItem} showSearch={false} />
      }
    </div>
  );
}

export default DiseaseList
